<nz-modal
  nzWrapClassName="vertical-center-modal"
  [(nzVisible)]="visible"
  [nzOkDisabled]="requestDisable"
  [nzTitle]="modalTitle"
  (nzOnCancel)="handleCancelModal($event)"
  (nzOnOk)="handleOkModal()"
  [nzWidth]="modalWidth"
  [nzOkText]="modalOkText"
  nzCancelText="Cancel"
>
  <div class="textSection" *ngIf="modalContext == 'requestEntitlement'">
    <div class="textSectionOne">
      Select brokers you'd like to be entitled to from the list of available
      brokers.
    </div>
    <div class="textSectionTwo">
      You will need to include your sales contacts' email and your physical work
      address with the entitlement request.
    </div>
  </div>
  <div class="textSection" *ngIf="modalContext == 'requestNewBroker'">
    <div class="textSectionOne">
      Select brokers you would like to receive content from below and click
      'add' to create a request.
    </div>
    <div class="textSectionTwo">
      You will need to include your sales contacts' email address<span
        style="font-weight:normal;"
        >, then our team will initiate discussions to help them join the
        platform.</span
      >
    </div>
  </div>
  <div
    *ngIf="modalContext == 'requestEntitlement'"
    nz-row
    nzType="flex"
    nzGutter="25"
    style="padding-top: 10px; font-size: 0.8em;"
  >
    <div nz-col nzSpan="4">
      <div>Your Details:</div>
      <span
        *ngIf="detailsErrorText.length > 0"
        class="error-class"
        style="padding-left: 0px;"
        >{{ detailsErrorText }}
      </span>
    </div>
    <div nz-col nzSpan="7">
      <input
        type="text"
        class="req-entitlement-details-input"
        nz-input
        placeholder="Street Address 1"
        [(ngModel)]="details.address1"
        [ngClass]="{ 'error-email': detailsErrorText && !details.address1 }"
      />
      <div
        nz-row
        nzType="flex"
        nzGutter="10"
        style="font-size: 0.8em; padding-top: 10px;"
      >
        <div nz-col nzSpan="12">
          <input
            type="text"
            class="req-entitlement-details-input"
            nz-input
            placeholder="City"
            [(ngModel)]="details.city"
            [ngClass]="{ 'error-email': detailsErrorText && !details.city }"
          />
        </div>
        <div nz-col nzSpan="12">
          <input
            type="text"
            class="req-entitlement-details-input"
            nz-input
            placeholder="Zip / Postal Code"
            [(ngModel)]="details.zip"
            [ngClass]="{ 'error-email': detailsErrorText && !details.zip }"
          />
        </div>
      </div>
      <div
        nz-row
        nzType="flex"
        nzGutter="10"
        style="font-size: 0.8em; padding-top: 10px;"
      >
        <div nz-col nzSpan="12">
          <input
            type="text"
            class="req-entitlement-details-input"
            nz-input
            placeholder="Telephone No."
            [(ngModel)]="details.tel"
          />
        </div>
        <div nz-col nzSpan="12">
          <input
            type="text"
            class="req-entitlement-details-input"
            nz-input
            placeholder="Role"
            [(ngModel)]="details.role"
          />
        </div>
      </div>
    </div>
    <div nz-col nzSpan="7">
      <input
        type="text"
        class="req-entitlement-details-input"
        nz-input
        placeholder="Street Address 2"
        [(ngModel)]="details.address2"
        [ngClass]="{ 'error-email': detailsErrorText && !details.address2 }"
      />
      <div
        nz-row
        nzType="flex"
        nzGutter="10"
        style="font-size: 0.8em; padding-top: 10px;"
      >
        <div nz-col nzSpan="12">
          <div
            [ngClass]="{ 'error-email': detailsErrorText && !details.country }"
          >
            <nz-select
              class="req-entitlement-details-input"
              nzShowSearch
              nzAllowClear
              nzPlaceHolder="Country"
              [(ngModel)]="details.country"
              (ngModelChange)="countrySelectionChanged($event)"
              [nzShowArrow]="false"
              [nzFilterOption]="countryFilter"
              style="width: 100%"
              [nzNotFoundContent]="countryNotFound"
              [nzSize]="'small'"
            >
              <nz-option
                *ngFor="let c of countries"
                [nzLabel]="c"
                [nzValue]="c"
              >
              </nz-option>
            </nz-select>
            <ng-template #countryNotFound>
              <div>
                <span style="font-weight: bold; color: black;"
                  >"{{ countryNotFoundText }}"</span
                >
                not found
              </div>
            </ng-template>
          </div>
        </div>
        <div
          nz-col
          nzSpan="12"
          *ngIf="details.country && details.country === 'United States'"
        >
          <div
            [ngClass]="{ 'error-email': detailsErrorText && !details.state }"
          >
            <nz-select
              class="req-entitlement-details-input"
              nzShowSearch
              nzAllowClear
              nzPlaceHolder="State"
              [(ngModel)]="details.state"
              [nzShowArrow]="false"
              [nzFilterOption]="stateFilter"
              style="width: 100%"
              [nzNotFoundContent]="stateNotFound"
              [nzSize]="'small'"
            >
              <nz-option *ngFor="let s of states" [nzLabel]="s" [nzValue]="s">
              </nz-option>
            </nz-select>
            <ng-template #stateNotFound>
              <div style="width: 200px;">
                <span style="font-weight: bold; color: black;"
                  >"{{ stateNotFoundText }}"</span
                >
                not found
              </div>
            </ng-template>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div
    nz-row
    nzType="flex"
    nzJustify="space-around"
    nzAlign="center"
    style="padding-top: 10px; font-size: 0.8em;"
  >
    <div nz-col [nzSpan]="modalContext == 'requestEntitlement' ? '5' : '7'">
      <div>Available Broker:</div>
      <div style="border: 1px solid lightgray; padding: 10px;">
        <nz-input-group [nzPrefix]="suffixIconSearch" class="search-box">
          <input
            type="text"
            nz-input
            placeholder="Search Brokers"
            [formControl]="queryField"
            style="height: 24px; font-size: 0.8em;"
          />
        </nz-input-group>
        <ng-template #suffixIconSearch>
          <i nz-icon nzType="search"></i>
        </ng-template>
        <br />
        <div class="broker-list">
          <nz-checkbox-wrapper
            style="width: 100%;"
            class="check-box-group"
            (nzOnChange)="onAvailableBrokerSelect($event)"
          >
            <div>
              <ng-container *ngFor="let val of brokerList; let i = index">
                <div *ngIf="val.visible">
                  <label
                    nz-checkbox
                    nzValue="{{ i }}"
                    [nzDisabled]="val.disabled"
                    [(ngModel)]="val.checked"
                    class="broker-label"
                    title="{{ val.label }}"
                    >{{ val.label }}</label
                  >
                </div>
              </ng-container>
            </div>
          </nz-checkbox-wrapper>
        </div>
      </div>
    </div>
    <div nz-col nzSpan="2" style="text-align: center;">
      <button
        nz-button
        nzType="default"
        [disabled]="stagedToAddBrokerIndices.length === 0"
        (click)="addToSelectedBrokers()"
        style="top: 100px;"
        title="Add Broker (s)"
      >
        <va-icon name="arrow-right"></va-icon>
      </button>
      <button
        nz-button
        nzType="default"
        [disabled]="stagedToRemoveBrokers.length === 0"
        (click)="removeSelectedBrokers()"
        style="top: 160px;"
        title="Remove Broker (s)"
      >
        <va-icon name="arrow-left"></va-icon>
      </button>
    </div>
    <div nz-col [nzSpan]="modalContext == 'requestEntitlement' ? '17' : '15'">
      <span *ngIf="modalContext == 'requestEntitlement'"
        >Selected Brokers and Requested Content Types:</span
      >
      <span *ngIf="modalContext == 'requestNewBroker'">Selected Brokers:</span>
      <span *ngIf="errorText.length > 0" class="error-class">{{
        errorText
      }}</span>
      <div style="border: 1px solid lightgray; height: 300px; padding: 10px; overflow: auto">
        <div>
          <div *ngIf="modalContext == 'requestNewBroker'">
            <nz-checkbox-wrapper (nzOnChange)="onSelectedBrokerSelect($event)">
              <div
                *ngFor="let val of selectedBrokers"
                style="padding-bottom: 10px;"
              >
                <label
                  nz-checkbox
                  [nzValue]="val.name"
                  class="broker-label selected-broker-label"
                  title="{{ val.name }}"
                  >{{ val.name }}</label
                >
                <input
                  type="text"
                  nz-input
                  placeholder="Enter sales contact email address"
                  style="width: 210px; float: right; height: 24px; font-size: 0.8em;"
                  [(ngModel)]="val.email"
                  [ngClass]="{ 'error-email': val.hasError }"
                />
              </div>
            </nz-checkbox-wrapper>
          </div>
          <div *ngIf="modalContext == 'requestEntitlement'">
            <nz-checkbox-wrapper (nzOnChange)="onSelectedBrokerSelect($event)">
              <div
                *ngFor="let val of selectedBrokers"
                style="padding-bottom: 10px;"
              >
                <label
                  nz-checkbox
                  [nzValue]="val.name"
                  class="broker-label selected-broker-label"
                  style="width: 150px; padding-right: 10px;"
                  title="{{ val.name }}"
                  >{{ val.name }}</label
                >
                <input
                  type="text"
                  nz-input
                  placeholder="Enter sales contact email address"
                  style="width: 210px; height: 24px; font-size: 0.8em; top: -8px;"
                  [(ngModel)]="val.email"
                  [ngClass]="{ 'error-email': val.hasError }"
                />
                <label
                  *ngIf="
                    val.modelLabel !== 'Request Entitlement' &&
                    val.modelLabel !== 'Expired'
                  "
                  nz-checkbox
                  [(ngModel)]="val.st_m"
                  class="broker-label selected-broker-label"
                  style="width: 127px; margin-left: 18px;"
                  nzDisabled
                  >{{ val.modelLabel }}</label
                >
                <label
                  *ngIf="
                    val.modelLabel === 'Request Entitlement' ||
                    val.modelLabel === 'Expired'
                  "
                  nz-checkbox
                  [(ngModel)]="val.st_m"
                  class="broker-label selected-broker-label"
                  [ngClass]="{ 'error-email': entErrorText && !val.st_m }"
                  style="width: 127px; margin-left: 18px;"
                  >Models</label
                >
                <label
                  *ngIf="
                    val.resLabel !== 'Request Entitlement' &&
                    val.resLabel !== 'Expired'
                  "
                  nz-checkbox
                  [(ngModel)]="val.st_r"
                  class="broker-label selected-broker-label"
                  style="width: 127px;"
                  nzDisabled
                  >{{ val.resLabel }}</label
                >
                <label
                  *ngIf="
                    val.resLabel === 'Request Entitlement' ||
                    val.resLabel === 'Expired'
                  "
                  nz-checkbox
                  [(ngModel)]="val.st_r"
                  class="broker-label selected-broker-label"
                  style="width: 127px;"
                  [ngClass]="{ 'error-email': entErrorText && !val.st_r }"
                  >Research</label
                >
                <span
                  *ngIf="entErrorText"
                  style="position: relative; float: right; top: 5px; color: red;"
                  title="Please select a content set for the entitlement request"
                >
                  <va-icon name="exclamation-triangle"></va-icon>
                </span>
              </div>
            </nz-checkbox-wrapper>
          </div>
        </div>
      </div>
    </div>
  </div>
</nz-modal>
